import { resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, renderList as _renderList, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0d388307"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "content"
};
const _hoisted_2 = {
  class: "back-content"
};
const _hoisted_3 = /*#__PURE__*/_createTextVNode("更新内容提示");
const _hoisted_4 = {
  key: 0,
  class: "message"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "发起人你好", -1));
const _hoisted_6 = {
  key: 0,
  class: "des"
};
const _hoisted_7 = {
  key: 1,
  class: "des"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "des"
}, "创建种草活动入口，如图", -1));
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "预热更新", -1));
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "des"
}, "1.产品更详细的介绍说明，为详情页补充；", -1));
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "des"
}, "2.开售前的预热抽奖；", -1));
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "des"
}, "3.开售前关于用户提出的产品的疑问的总结回答；", -1));
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "日常更新", -1));
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "des"
}, "1.主题建议：开发手记/创作过程/打样实拍/其他话题互动，或针对用户提出的问题或者建议进行回答；", -1));
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "des"
}, "2.每达成一次解锁目标需要及时用更新与用户同步，同时最好可以展示解锁品的细节；", -1));
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "des"
}, "3.若有新增档位/解锁福利/权益调整，及时发布更新，跟用户同步消息，可以促使新档位更好的售卖效果；", -1));
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "众筹目标达成更新", -1));
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "des"
}, "1.主要内容是跟用户分享众筹成功的喜悦，以及提示项目的活动和后续的解锁进展；", -1));
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "众筹即将结束更新", -1));
const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "des"
}, "1.推荐发布倒计时冲刺的项目更新，盘点项目福利、以及若有临近解锁的产品可以提前解锁，给到用户最大福利，促进未下单的用户抓紧时间下单购买，促使还没有入坑的用户抓紧时间入坑；", -1));
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "众筹结束更新", -1));
const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "des"
}, "1.主题建议：感谢大家支持/后续发货等进度安排/其他想和大家说的话；", -1));
const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "众筹结束后发货前", -1));
const _hoisted_24 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "des"
}, "1.项目结束后推荐每月促使CP发布一次更新，此时的更新内容偏向于产品大货制作的过程以及进展，这个时期的更新有助于减少后期用户的退货率；", -1));
const _hoisted_25 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "众筹即将发货更新", -1));
const _hoisted_26 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "des"
}, "1.众筹发货前2周发布项目更新通知用户确认是否需要修改地址，以及最晚的修改地址时间；", -1));
const _hoisted_27 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "众筹发货后", -1));
const _hoisted_28 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "des"
}, "1.主题建议：告知用户发货进度/收货注意事项/产品售后规则/再次感谢支持。如果有开通摩点店铺，可以推荐在更新内插入店铺的链接，引导还未下单的用户下单；", -1));
const _hoisted_29 = {
  key: 1,
  class: "tips"
};
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" 请复制链接后在电脑端打开，并完成发布更新");
const _hoisted_31 = {
  key: 2,
  class: "btns"
};
const _hoisted_32 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_icon = _resolveComponent("van-icon");
  const _component_van_image = _resolveComponent("van-image");
  const _component_van_popup = _resolveComponent("van-popup");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_popup, {
    show: $options.ifShow,
    "onUpdate:show": _cache[2] || (_cache[2] = $event => $options.ifShow = $event),
    class: "pop-back",
    position: "bottom",
    style: {
      "height": "calc(100% - 90px)"
    }
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
      class: _normalizeClass(["tit", _ctx.has_message])
    }, [_hoisted_3, _createVNode(_component_van_icon, {
      class: "icon",
      name: "close",
      size: "20",
      onClick: _cache[0] || (_cache[0] = _withModifiers($event => $options.btnAction($event, 0), ["stop"]))
    })], 2), $data.is_loading == false ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_hoisted_5, $data.hava_pro ? (_openBlock(), _createElementBlock("div", _hoisted_6, " 你的项目「" + _toDisplayString($data.pro_title) + "」目前处于" + _toDisplayString($data.pro_status_str) + "，你可发布有奖种草活动，有助于在小红书内传播提高项目热度。", 1)) : (_openBlock(), _createElementBlock("div", _hoisted_7, " 你无项目/项目已结束。你若有处于预热阶段/众筹中的项目，你可发布有奖种草活动，有助于在小红书内传播提高项目热度。")), _hoisted_8, _createVNode(_component_van_image, {
      class: "example",
      src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/merchant/red_note_update_exanple.png', 690)
    }, null, 8, ["src"]), _ctx.tips_type == 1 ? (_openBlock(), _createElementBlock(_Fragment, {
      key: 2
    }, [_hoisted_9, _hoisted_10, _hoisted_11, _hoisted_12], 64)) : _ctx.tips_type == 2 ? (_openBlock(), _createElementBlock(_Fragment, {
      key: 3
    }, [_hoisted_13, _hoisted_14, _hoisted_15, _hoisted_16, _hoisted_17, _hoisted_18, _hoisted_19, _hoisted_20], 64)) : _ctx.tips_type == 3 ? (_openBlock(), _createElementBlock(_Fragment, {
      key: 4
    }, [_hoisted_21, _hoisted_22], 64)) : _ctx.tips_type == 4 ? (_openBlock(), _createElementBlock(_Fragment, {
      key: 5
    }, [_hoisted_23, _hoisted_24, _hoisted_25, _hoisted_26], 64)) : _ctx.tips_type == 5 ? (_openBlock(), _createElementBlock(_Fragment, {
      key: 6
    }, [_hoisted_27, _hoisted_28], 64)) : _createCommentVNode("", true)])) : _createCommentVNode("", true), $data.is_loading == false && $data.hava_pro && $options.isMobile ? (_openBlock(), _createElementBlock("div", _hoisted_29, [_createVNode(_component_van_icon, {
      class: "icon",
      name: "info-o",
      size: "18"
    }), _hoisted_30])) : _createCommentVNode("", true), $data.is_loading == false && $data.hava_pro ? (_openBlock(), _createElementBlock("div", _hoisted_31, [$options.isMobile == true ? (_openBlock(), _createElementBlock(_Fragment, {
      key: 0
    }, _renderList(['取消', '复制链接'], (item, index) => {
      return _createElementVNode("div", {
        class: _normalizeClass(['btn', {
          'active': 1 == index
        }]),
        key: index,
        onClick: $event => $options.btnAction($event, index)
      }, _toDisplayString(item), 11, _hoisted_32);
    }), 64)) : (_openBlock(), _createElementBlock("div", {
      key: 1,
      class: _normalizeClass(['btn', 'active']),
      onClick: _cache[1] || (_cache[1] = $event => $options.btnAction($event, 1))
    }, "立即发布更新"))])) : _createCommentVNode("", true)])]),
    _: 1
  }, 8, ["show"])]);
}